import { useEffect } from 'react'
import classes from './Header.module.css'
import { ReactComponent as XSvg } from '../../../assets/NewX.svg';
import { ReactComponent as DragSvg } from '../../../assets/NewMove.svg';
import { ReactComponent as Chats } from '../../../assets/Chats.svg';
import { ReactComponent as OpenWide } from '../../../assets/NewArrowSquareOut.svg';
import { useDispatch, useSelector } from 'react-redux';
import { toggle } from '../sidebar/sidebarSlice'

function Header() {
  const isMobile = useSelector(state => state.layout).isMobile
  const dispatch = useDispatch()
  const sidebarState = useSelector(state => state.sidebar)

  useEffect(() => {
      function dragElement(elmnt) {
          var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
          elmnt.onmousedown = dragMouseDown;
          function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.screenX;
            pos4 = e.screenY;
            document.onmouseup = closeDragElement;
            document.onmouseleave = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
          }
        
          function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.screenX;
            pos2 = pos4 - e.screenY;
            pos3 = e.screenX;
            pos4 = e.screenY;
            // set the element's new position:
            window.parent.postMessage("framelocation;"+pos1+";"+pos2,"*")        
          }
        
          function closeDragElement() {
            // stop moving when mouse button is released:
            document.onmouseleave = null
            document.onmouseup = null;
            document.onmousemove = null;
          }
      }
      dragElement(document.getElementById("dragHeader"))   
  })

  let onClick = () => {
      window.parent.postMessage("closeBot","*")
  }

  let wideHandler = () => {
      window.parent.postMessage("wide_window","*")
  }

  let chatsToggleHandler = () => {
    if (sidebarState.isOpen) {
      dispatch(toggle({isOpen: false}))
    } else {
      dispatch(toggle({isOpen: true}))
    }
  }

  return (
      <div id="dragHeader" className={classes.Header}>

          <div onClick={onClick} className={classes.CloseButton}>
            <XSvg/>
          </div>
          {!isMobile ? <div className={classes.DragButton}>
            <DragSvg/>
          </div> :  <div className={classes.ChatsContainer}>
            <div className={classes.ChatsButton} onClick={chatsToggleHandler}>
              <Chats/>
              </div>
          </div>}
          {!isMobile ? <div onClick={wideHandler} className={classes.DragButton}>
            <OpenWide/>
          </div> : null}
      </div>
  );
}

export default Header;
